import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-fill text-accent-500 text-xl"></i>
              </div>
              <span className="font-heading text-lg text-foreground-950">免费电影</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              汇聚海量高清免费电影资源，涵盖国产、好莱坞、动漫、纪录片等全类型，无需注册、无需付费，随时随地畅享免费电影观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">电影分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">热门推荐</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/sci-fi" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">
                  科幻电影推荐
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">
                  动作电影排行榜
                </Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">
                  喜剧电影精选
                </Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">
                  动漫电影大全
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">关于本站</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <span className="text-sm text-foreground-500">联系邮箱：contact@freemoviehub.cn</span>
              </li>
              <li>
                <span className="text-sm text-foreground-500">每日更新，精彩不停</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 免费电影在线观看 - 本站所有资源均来自网络，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">
              隐私政策
            </a>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">
              使用条款
            </a>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}